/**
 * @property {String|null} email
 * @property {String|null} firstname
 * @property {String|null} lastname
 * @property {String|null} id
 */
export default class Manager {
    constructor() {
        this.email = null;
        this.firstname = null;
        this.lastname = null;
        this.id = null;
    }

    /**
     * Returns a new `Manager` instance hydrated with data from given `api_resource`.
     *
     * @param {object} api_resource
     * @return {Manager}
     */
    static fromAPI(api_resource) {
        return Object.assign(new Manager(), {
            email: api_resource.email,
            firstname: api_resource.firstname,
            lastname: api_resource.lastname,
            id: api_resource.id
        });
    }

    /**
     * @return {string}
     */
    get fullName() {
        return `${this.firstname} ${this.lastname}`.trim();
    }
}
